<div class="content-layout">
  <router-outlet></router-outlet>
</div>
